<template>
  <v-container>
  <div class="text-center">
    <h1  class="font-weight-light">Your personal information</h1>
  </div>
  <v-card
    class="mx-auto"
    max-width="840"
  >
    <v-card-title>
      Basic summary
    </v-card-title>

    <v-card-text>
      <v-container fluid>
        <v-row dense align="center" justify="center">
          <v-col class="text-center">
            <v-avatar color="blue">
              <span class="white--text headline">{{user ? user.Initials : '' }}</span>
            </v-avatar>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-text>
      <v-container fluid>
        <v-row dense align="center" justify="center">
          <v-col>
            <div class="my-4 text-h6">
              Name
            </div>
            <div>{{user ? user.First : '' }} {{user ? user.Last : '' }}</div>
          </v-col>
          <v-col class="text-right">
            <v-btn icon disabled>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    
    <v-divider class="mx-4"></v-divider>
    
    <v-card-text>
      <v-container fluid>
        <v-row dense align="center" justify="center">
          <v-col>
            <div class="my-4 text-h6">
              Birthday
            </div>
            <div>{{user ? user.Birhday : '' }}</div>
          </v-col>
          <v-col class="text-right">
            <v-btn icon disabled>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>
    
    <v-card-text>
      <v-container fluid>
        <v-row dense align="center" justify="center">
          <v-col>
            <div class="my-4 text-h6">
              Gender
            </div>
            <div>{{user ? user.Birhday : '' }}</div>
          </v-col>
          <v-col class="text-right">
            <v-btn icon disabled>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>
    
    <v-card-text>
      <v-container fluid>
        <v-row dense align="center" justify="center">
          <v-col>
            <div class="my-4 text-h6">
              Password
            </div>
            <div>****</div>
            <div>Last updated {{user ? user.lastPswUpdate : '' }}</div>
          </v-col>
          <v-col class="text-right">
            <v-btn
              icon
              exact
              to="password-update"
             >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>

  <v-card
    class="mx-auto mt-5"
    max-width="840"
  >
    <v-card-title>
      Contact information
    </v-card-title>

    <v-card-text>
      <v-container fluid>
        <v-row dense align="center" justify="center">
          <v-col>
            <div class="my-4 text-h6">
              Email
            </div>
            <div>{{user ? user.Email : '' }}</div>
          </v-col>
          <v-col class="text-right">
            <v-btn icon disabled>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Profile",
  computed: {
    user() {
      return this.$store.state.user.user
    }
  },
  data() {
    return {
      drawer: null
    }
  }
}
</script>